<div
  class="preview-result-item-container"
  [ngClass]="{
    selected: selected,
    'people-preview-large': (!smallWidthPreview && size !== 'popup') || previewPopupLarge,
  }"
  *ngIf="item.model?.view"
>
  <div class="preview-result-item-main">
    <div class="icon-container">
      <u-icon
        class="icon-logo"
        [styles]="{ width: '24px', height: '24px' }"
        [model]="generateIcon(item?.model.view?.icon)"
        *ngIf="item?.model.view?.icon"
      ></u-icon>
      <u-icon
        class="icon-overlay"
        iconCtx="style"
        [styles]="{ width: '14px', height: '14px', backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }"
        [model]="generateIcon(item?.model.view?.iconOverlay)"
        *ngIf="item?.model.view?.iconOverlay"
      ></u-icon>
    </div>
    <div class="preview-result-item-wrapper-titles">
      <div class="preview-result-item-wrapper-title">
        <span class="title" [innerHTML]="item?.model?.view?.title?.text"></span>
        <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
          <div class="favorite" *ngIf="item?.model.isFavorite">
            <u-icon [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
          </div>
        </ng-container>
      </div>
      <span class="preview-result-item-wrapper-sub-title" *ngIf="subTitleView">
        <span *ngIf="subTitleView?.title" class="sub-title">{{ subTitleView?.title }}</span>
        <span class="sub-title name">{{ subTitleView?.name }}</span>
        <span class="sub-title time">{{ subTitleView?.time }}</span>
      </span>
    </div>
  </div>
  <div class="restricted">
    <restricted-message *ngIf="restrictedLink" class="restricted-message"></restricted-message>
    <square-button
      *ngIf="showResultSections.showContextMenu"
      [active]="contextMenuHelper?.source === 'actions'"
      (click)="openContextMenu($event, 'actions')"
      >•••</square-button
    >
  </div>
</div>
